import React from 'react'
import styled from '@emotion/styled'
import L1Hamburger from './L1Hamburger'
import Logo from '../art/Logo'

const SizedLogo = styled(Logo)(({theme}) => (({
	color: theme.colors.white,
	width: 76.456,
})))

interface ShmoopieProps {
	className?: string
	hamburgerOpen?: boolean
	onHamburgerClick?: React.MouseEventHandler<HTMLButtonElement>
}

const Shmoopie = ({className, hamburgerOpen = false, onHamburgerClick}: ShmoopieProps) => {
	return (
		<div className={className}>
			<L1Hamburger open={hamburgerOpen} onClick={onHamburgerClick} />
			<SizedLogo />
		</div>
	)
}

export const L1BaseShmoopie = styled(Shmoopie)(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	columnGap: theme.spacing(2),
	backgroundColor: theme.colors.orangeMain,
	borderBottomRightRadius: '20px',
	color: 'white',
	padding: theme.spacing(2, 2.5),
}))
